import React, { useEffect, useRef } from 'react';
import './Experiences.css';

const SLIDER_SELECTOR = '.tv-image-slider.tv-moduleid-9995375';

const runTourvisorInit = () => {
  try {
    if (typeof window.TV?.loadModules === 'function') {
      window.TV.loadModules();
      return;
    }
    if (typeof window.TV?.init === 'function') window.TV.init();
    if (typeof window.Tv?.init === 'function') window.Tv.init();
    if (typeof window.tourvisorInit === 'function') window.tourvisorInit();
  } catch (err) {
    console.warn('Tourvisor slider init error:', err);
  }
};

const unlockEmptySlider = () => {
  const el = document.querySelector(SLIDER_SELECTOR);
  if (el && el.childElementCount === 0) el.classList.remove('tv-loaded');
};

const Experiences = () => {
  const mountKeyRef = useRef(Date.now());

  useEffect(() => {
    let cancelled = false;
    const timers = [];
    let started = false;

    const start = () => {
      if (cancelled || started) return;
      started = true;
      unlockEmptySlider();
      runTourvisorInit();
      [1000, 2500, 5000].forEach((delay) => {
        timers.push(
          window.setTimeout(() => {
            if (cancelled) return;
            unlockEmptySlider();
            runTourvisorInit();
          }, delay)
        );
      });
    };

    if (window.TV?.loadModules || window.TV?.init) {
      timers.push(window.setTimeout(start, 0));
    } else {
      const waitId = window.setInterval(() => {
        if (window.TV?.loadModules || window.TV?.init) {
          window.clearInterval(waitId);
          start();
        }
      }, 100);
      timers.push(waitId);
      timers.push(
        window.setTimeout(() => {
          window.clearInterval(waitId);
          if (!started) start();
        }, 8000)
      );
    }

    return () => {
      cancelled = true;
      timers.forEach((id) => {
        window.clearTimeout(id);
        window.clearInterval(id);
      });
    };
  }, []);

  return (
    <section className="experiences-section page-section">
      <div className="page-container">
        <h2 className="section-title">Популярные направления</h2>
        <p className="section-subtitle">
          Подборка туров, которые чаще всего выбирают наши клиенты.
        </p>

        <div className="experiences-tourvisor-slider" key={mountKeyRef.current}>
          <div className="tv-image-slider tv-moduleid-9995375" />
        </div>
      </div>
    </section>
  );
};

export default Experiences;
